import {
  type GetBuildingSurveyPartsRes,
  type GetBuildingSurveyQuestsRes,
} from "./res";
import {
  type AnswerSurveyReq,
  type GetBuildingSurveyPartsReq,
  type GetBuildingSurveyQuestsReq,
} from "./req";
import { spApiInstance } from "api/instance";
import { SP_NAMES } from "api/constants";

export const answerSurveyApi = (body: AnswerSurveyReq) => {
  return spApiInstance<void>(SP_NAMES.answerSurvey, body);
};

export {
  AnswerSurveyReq,
  GetBuildingSurveyPartsReq,
  GetBuildingSurveyPartsRes,
  GetBuildingSurveyQuestsReq,
  GetBuildingSurveyQuestsRes,
};
